import React, { memo, useEffect, useState } from 'react'
import { Button, HeadingText, Avatar, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import DsrBanner from '../common/dsr-banner'
import { ZETTLE_US_URL } from '../../../constants/constants'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'

const VerificationSuccess = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.EMAILVERIFICATION_SUCCESS_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])
  const bannerContent = {
    header: <Message id="dsrZettle.email.verification.header.title" />,
    description: '',
  }
  const handleLinkClick = (event) => {
    event.preventDefault()
    fptiCustomClick(dsrFpti.EMAILVERIFICATION_SUCCESS_LINKCLICK)
    location.href = ZETTLE_US_URL
  }
  return (
    <>
      <DsrBanner {...bannerContent} />
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-success.svg"
                className="focusedimg"
                alt="success"
              />
            </div>
            <HeadingText size="sm" className="text-center">
              <Message id="dsrZettle.email.verification.body.title" />
            </HeadingText>
            <p className="text-center margintop16">
              <Message id="dsrZettle.email.verification.body.description" />
            </p>
            <p className="text-center">
              <span>
                <Message id="dsrZettle.email.verification.body.requestid" />
              </span>
              <span>: {props.reqid}</span>
            </p>
            <div className="button-container">
              <Button size="sm" secondary>
                <Message
                  id="dsrZettle.email.verification.body.another.request"
                  link={(innerMessage) => (
                    <Link href="/" onClick={handleLinkClick}>
                      {innerMessage}
                    </Link>
                  )}
                />
              </Button>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
VerificationSuccess.displayName = 'VerificationSuccess'

export default VerificationSuccess
